"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../Icon"));
var Label_1 = __importDefault(require("../Label"));
var Validation_1 = __importDefault(require("../Validation"));
var Hint_1 = __importDefault(require("../Hint"));
var styles_1 = require("./styles");
var FALLBACK_COUNTER_MAX_LENGTH = 32;
var TextInput = function (_a) {
    var _b, _c, _d;
    var label = _a.label, onIconClick = _a.onIconClick, validation = _a.validation, required = _a.required, iconName = _a.iconName, iconColorType = _a.iconColorType, forwardRef = _a.forwardRef, characterCounter = _a.characterCounter, hint = _a.hint, validationType = _a.validationType, props = __rest(_a, ["label", "onIconClick", "validation", "required", "iconName", "iconColorType", "forwardRef", "characterCounter", "hint", "validationType"]);
    var _e = (0, react_1.useState)(false), isPasswordVisible = _e[0], setIsPasswordVisible = _e[1];
    var isPassword = props.type === 'password';
    var _f = (0, react_1.useState)((_c = (_b = props.value) === null || _b === void 0 ? void 0 : _b.toString().length) !== null && _c !== void 0 ? _c : 0), characterCount = _f[0], setCharacterCount = _f[1];
    var handleInputChange = function (event) {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
        setCharacterCount(event.target.value.length);
    };
    var handleTogglePasswordVisibility = function () {
        setIsPasswordVisible(function (value) { return !value; });
    };
    var isErrorValidation = !!validation && (validationType === 'error' || validationType === undefined);
    var getAriaLabel = function () {
        if (props['aria-label'])
            return props['aria-label'];
        var ariaLabel = label || '';
        // if (required && label) ariaLabel += ' (required)';
        if (props.placeholder && !label)
            ariaLabel = props.placeholder;
        if (hint && !ariaLabel)
            ariaLabel = hint;
        return ariaLabel;
    };
    var getDescribedBy = function () {
        if (validation) {
            return "".concat(props.id || '', "-validation");
        }
        if (hint) {
            return "".concat(props.id || '', "-hint");
        }
        return undefined;
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ disabled: props.disabled }, { children: [label && ((0, jsx_runtime_1.jsx)(Label_1.default, __assign({ validated: isErrorValidation, required: required, htmlFor: props.id || "".concat(props.name || 'input') }, { children: label }))), (0, jsx_runtime_1.jsxs)(styles_1.InputContainer, { children: [(0, jsx_runtime_1.jsx)(styles_1.Input, __assign({ ref: forwardRef, className: (0, classnames_1.default)({ validation: isErrorValidation }) }, props, { id: props.id || "".concat(props.name || 'input') }, (isPasswordVisible && { type: 'text' }), { onChange: handleInputChange, "aria-label": getAriaLabel(), "aria-required": required, "aria-invalid": !!validation, "aria-describedby": getDescribedBy() })), isPassword && ((0, jsx_runtime_1.jsx)(styles_1.PasswordVisibilityToggle, __assign({ "data-testid": "password-eye-icon", onClick: handleTogglePasswordVisibility, tabIndex: -1, type: "button" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: isPasswordVisible ? 'visibility-off-outline' : 'visibility-on-outline' }) }))), iconName && ((0, jsx_runtime_1.jsx)(styles_1.IconContainer, __assign({ onClick: onIconClick, style: { cursor: onIconClick ? 'pointer' : 'default' }, iconColorType: iconColorType }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName }) })))] }), (0, jsx_runtime_1.jsxs)(styles_1.BottomRow, __assign({ validation: validation, hint: hint }, { children: [validation && ((0, jsx_runtime_1.jsx)(Validation_1.default, __assign({ type: validationType, id: "".concat(props.id || '', "-validation") }, { children: validation }))), hint && !validation && (0, jsx_runtime_1.jsx)(Hint_1.default, __assign({ id: "".concat(props.id || '', "-hint") }, { children: hint })), characterCounter ? ((0, jsx_runtime_1.jsxs)(styles_1.CharacterCounter, __assign({ "data-testid": "character-counter", size: "sm" }, { children: [characterCount, "/", (_d = props.maxLength) !== null && _d !== void 0 ? _d : FALLBACK_COUNTER_MAX_LENGTH] }))) : null] }))] })));
};
exports.default = TextInput;
